export default [
    {
        path: '/studyplan',
        name: 'studyplan',
        component: () => import('@/views/layout/studyPlan/index'),
        meta: {
            title: '学习计划'
        }
    },
]